import { ScheduleAxis } from 'src/app/models/enums';

export function dragAxis(dx: number, dy: number, threshold: number, horizontalOnly = false): ScheduleAxis | undefined {
  if (horizontalOnly) {
    return Math.abs(dx) >= threshold ? ScheduleAxis.HORIZONTAL : undefined;
  }
  if (Math.max(Math.abs(dx), Math.abs(dy)) < threshold) {
    return undefined;
  }
  return Math.abs(dx) >= Math.abs(dy) ? ScheduleAxis.HORIZONTAL : ScheduleAxis.VERTICAL;
}

export function snapMinutes(minutes: number, step: number): number {
  return Math.round(minutes / step) * step;
}

export function clampShift(shiftMinutes: number, startMinutes: number, endMinutes: number, axisStart: number, axisEnd: number): number {
  return Math.min(Math.max(shiftMinutes, axisStart - startMinutes), axisEnd - endMinutes);
}
